import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from './spinner.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@NgModule({
  imports: [
    CommonModule,
    ProgressSpinnerModule
  ],
  declarations: [SpinnerComponent],
  bootstrap: [SpinnerComponent],
  exports: [SpinnerComponent]
})
export class SpinnerModule { }
